<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <span class="w-title">开票信息管理</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <v-layout wrap>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filters.type"
            label="请选择发票类型"
            :items="types"
            outline
            solo
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3 style="display: flex;align-items: baseline">
          <v-menu
            v-model="showStartDate"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filters.startDate"
                label="开票开始日期"
                readonly
                outline
                solo
                style="width:45%"
                class="xn-date"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.startDate"
              locale="zh-cn"
              @input="showStartDate = false"
            ></v-date-picker>
          </v-menu>
          <span class="mx-2">至</span>
          <v-menu
            v-model="showEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filters.endDate"
                label="开票结束日期"
                readonly
                outline
                solo
                style="width:45%"
                class="xn-date"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.endDate"
              locale="zh-cn"
              @input="showEndDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            v-model="filters.q"
            label="公司名称"
            outline
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 style="display: flex;margin-bottom: 20px;">
          <v-btn color="info" style="margin-right: 5px !important;" @click="refresh">查询</v-btn>
          <v-btn color="info" @click="clearFilters">重置</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn color="info" style="margin-right: 5px !important;" @click="addButtonClicked">新建</v-btn>
    <v-btn color="error" :disabled="canDelete" style="margin-right: 5px !important;" @click="deleteButtonClicked">删除</v-btn>
    <v-btn color="success" style="margin-right: 5px !important;" @click="openDialog">导入</v-btn>
    <v-btn color="success" :disabled="canExport" outline style="margin-right: 5px !important;" @click="exportButtonClicked">导出</v-btn>

    <DataTable
      ref="dataTable"
      item-key="receiptId"
      sort-by="createDate"
      :show-footer="true"
      :headers="headers"
      :fetch-data="refreshList"
      :total-price="totalPrice"
      :total-tax="totalTax"
      @editButtonClicked="editButtonClicked"
      @detailButtonClicked="detailButtonClicked"
    >
    </DataTable>

    <v-dialog v-model="showImportDialog" max-width="500px">
      <v-card>
        <v-card-title>导入</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md class="xn-form">
            <v-layout wrap>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">公司:</label>
              </v-flex>
              <v-flex xs10>
                <v-autocomplete
                  ref="form.companyId"
                  v-model="item.companyId"
                  no-data-text="无可用数据"
                  :items="companies"
                  label="请选择公司"
                  :rules="[rules.required]"
                  outline
                  solo
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">Excel:</label>
              </v-flex>
              <v-flex xs10>
                <upload-btn
                  title="上传文件"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  no-title-update
                  style="display: inline-block;padding-left: 0;"
                  @file-update="fileUpdate"
                >
                </upload-btn>
                <v-chip v-if="file" close style="margin: 0;" @input="clearFile">
                  {{ file.name }}
                </v-chip>
              </v-flex>
              <v-flex xs10 offset-xs2 class="mt-4">
                <v-btn flat outline style="margin-right: 10px !important;" @click="showImportDialog = false">返回</v-btn>
                <v-btn color="info" @click="saveImport">保存</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  /**
   * 开票信息
   */
  import axios from "../axios";
  import DataTable from "../components/DataTable2";
  import {dateFormat} from "vue-filter-date-format";
  import {mapState, mapActions} from 'vuex';
  import UploadButton from "vuetify-upload-button";

  export default {
    mounted() {
      this.isMounted = true;
    },
    components: {
      DataTable,
      "upload-btn": UploadButton,
    },
    computed: {
      ...mapState({
        companies: state => state.miniCompanies,
      }),
      canDelete() {
        if (this.isMounted) {
          return this.$refs.dataTable.selected.length === 0;
        } else {
          return false;
        }
      },
      canExport() {
        if (this.isMounted) {
          return this.$refs.dataTable.data.length === 0;
        } else {
          return false;
        }
      }
    },
    data: () => ({
      isMounted: false,
      headers: [
        {text: '公司名称', value: 'companyName'},
        {text: '购方公司名称', value: 'toCompanyName'},
        {text: '发票类型', value: 'type'},
        {text: '开票日期', value: 'receiptDate'},
        {text: '金额合计(元)', value: 'totalPrice', sortable: false, customClass: 'money'},
        {text: '税额合计(元)', value: 'totalTax', sortable: false, customClass: 'money'},
        {text: '价税合计(元)', value: 'total', sortable: false, customClass: 'money'},
        {text: "操作", align: "center", value: "settings", sortable: false}
      ],
      filters: {},
      types: ["普通发票", "专用发票"],
      showStartDate: false,
      showEndDate: false,
      showImportDialog: false,
      rules: {required: value => !!value || "必填"},
      item: {
        companyId: null
      },
      file: null,
      hasErrors: false,
      totalPrice: 0,
      totalTax: 0,
      ts: '',
      params: null,
    }),
    methods: {
      ...mapActions(['setLoading']),
      refreshList(pagination, searchText, callback, failure) {

        let createMin = this.filters.startDate ? `gte(${this.filters.startDate})` : 'gte(1970-01-01)';
        let createMax = this.filters.endDate ? `and(lte(${this.filters.endDate}))` : 'and(lte(2099-12-31))';
        let ts = `?receiptDate=${createMin}&receiptDate=${createMax}`;
        this.ts = ts;
        this.params = {
          params: {
            page: pagination.page - 1,
            size: pagination.rowsPerPage === -1 ? 2147483647 : pagination.rowsPerPage,
            sort:
              pagination.sortBy === null
                ? null
                : pagination.sortBy +
                "," +
                (pagination.descending ? "desc" : "asc"),
            companyId: this.$currentCompany ? this.$currentCompany.id : null,
            ...this.filters,
            receiptDate: null,
            endDate: null
          }
        };

        axios
          .get("/receipts" + this.ts, this.params)
          .then(response => {
            this.totalPrice = response.data.totalPrice;
            this.totalTax = response.data.totalTax;
            callback(response.data.total, response.data.data);
          })
          .catch(reason => {
            if (failure) {
              failure(reason);
            }
          });
      },
      exportButtonClicked() {
        this.setLoading(true);
        axios
          .get("/receipts/export" + this.ts, { ...this.params, responseType: "arraybuffer" })
          .then(response => {
            this.saveAs(new Blob([response.data]), "发票.csv");
            this.setLoading(false);
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      addButtonClicked() {
        this.$router.push({
          name: "receipt-form-add"
        });
      },
      editButtonClicked(item) {
        this.$router.push({
          name: "receipt-form-edit",
          params: {receiptId: item.receiptId}
        });
      },
      detailButtonClicked(item) {
        this.$router.push({
          name: "receipt-form-detail",
          params: {receiptId: item.receiptId}
        });
      },
      deleteButtonClicked() {
        let items = this.$refs.dataTable.selected;
        this.$confirm("正在删除" + items.length + "个开票信息，请确认").then(
          res => {
            if (res) {
              this.setLoading(true);
              axios
                .post("/receipts/delete", {
                  receiptIds: items.map(item => item.receiptId)
                })
                .then(() => {
                  this.setLoading(false);

                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.refresh();
                    }
                  );
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {
                    buttonFalseText: null
                  });
                  this.setLoading(false);
                });
            }
          }
        );
      },
      fileUpdate(file) {
        this.file = file;
      },
      clearFile() {
        this.file = null;
      },
      openDialog() {
        this.showImportDialog = true;
        this.item = {companyId: null};
        this.file = null;
        this.resetForm();
      },
      validate() {
        this.hasErrors = false;
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },
      saveImport() {
        //保存导入
        this.validate();
        if (!this.file) {
          this.$confirm('附件不能为空', {buttonFalseText: null});
          return;
        }

        if (!this.hasErrors) {
          let formData = new FormData();
          formData.append("file", this.file);
          formData.append("data", JSON.stringify(this.item));

          axios.post(`/companies/${this.item.companyId}/receipts/import`, formData, {
            headers: {"Content-Type": "multipart/form-data"}
          })
            .then(() => {
              this.setLoading(false);

              this.$confirm("导入成功", {buttonFalseText: null}).then(() => {
                this.showImportDialog = false;
                this.refresh();
              });
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {buttonFalseText: null});
              this.setLoading(false);
            });
        }
      },
      refresh() {
        this.$refs.dataTable.refresh();
      },
      clearFilters() {
        this.filters = {};
        this.refresh();
      }
    }
  }
</script>

<style scoped>

</style>
